import React, {
  useContext,
} from 'react';
import {
  MultiMediaResponse,
} from 'dtos';
import {
  FileViewerContext,
} from 'pages/Dashboard/contexts/fileViewer';
import Carousel from 'pages/Dashboard/components/Carousel';

export default function usePreviewCarousel() {
  const { openDialog } = useContext(FileViewerContext);

  return (mediaList: MultiMediaResponse[]) => openDialog({
    content: <Carousel mediaList={mediaList} />,
  });
}
